import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type { FilterState } from '@/features/filterSlice';
import { FUEL_HAZARD_RATINGS } from '@/features/types';
import { getRatingId } from '@/helpers/encroachmentRating';
import { useClientTerminology } from '@/views/list/NetworkTerms';

export const FuelHazardRatingFilter = (props: {
  control: Control<FilterState>;
}) => {
  const intl = useClientTerminology();

  const fuelHazardRatingOptions = FUEL_HAZARD_RATINGS.map((rating) => ({
    value: String(rating),
    label: intl.formatMessage({ id: getRatingId(rating) }),
  }));

  return (
    <Controller
      control={props.control}
      name="fuelHazardRatings"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label={intl.formatMessage({ id: 'filter.fuelHazardRating.title' })}
            placeholder={intl.formatMessage({
              id: 'filter.fuelHazardRating.allRatings',
            })}
            options={fuelHazardRatingOptions}
            onChange={onChange}
            onBlur={onBlur}
            value={fuelHazardRatingOptions.filter((c) =>
              value.includes(c.value)
            )}
            maxMenuHeight={150}
          />
        );
      }}
    />
  );
};
